import { ScheduleType } from '../../../../shared/src/data/scheduleType';
import { ViewType } from '../viewType';
import { BoundingBox } from './BoundingBox'

export class UIRegionOfInterest {
  constructor(
    public readonly id: string,
    public readonly fileId: string,
    public readonly page: number,
    public readonly boundingBoxInNormalizedCoordinates: BoundingBox,
    public regionContentType: ViewType[],
    public label: ScheduleType,
    public textLabel: string = '',
  ) {}
}